import React, { useContext } from "react";
import { UserContext } from "../contexts/userContext";
import nl from "../../assets/translations/nl.json";

export const T = ({ str }: { str: string }) => {
  let languageTable = {};
  let localStorageLanguage = localStorage.getItem("language");
  if (useContext(UserContext)) {
    const { user } = useContext(UserContext);

    switch (user.language) {
      case "en":
        languageTable = {};
        break;
      case "nl":
        languageTable = nl;
        break;
    }
  } else if (localStorageLanguage) {
    switch (localStorageLanguage) {
      case "en":
        languageTable = {};
        break;
      case "nl":
        languageTable = nl;
        break;
    }
  } else {
    languageTable = {};
  }

  const translation = languageTable[str];
  return (
    <>
      {translation && translation !== "NEEDS TRANSLATION" ? translation : str}
    </>
  );
};
